'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Header, Footer, FAQ } from '../..';
import { titleColumn, column1, column2, column3 } from '../../../utils';
import { question, appstorebtn, googleplaybtn, brandlogo } from '../../../assets';
import PricingHeader from '../../pricingheader/PricingHeader';

import styles from './pricing.module.css';

const Pricing = () => {
  return (
    <main className={styles.main}>
      <div className={styles.firstFrame}>
        <div className={styles.firstFramewrapper}>
          <Header brand={brandlogo} brandToggle={brandlogo} mobileBrand={brandlogo} />
          <div className={styles.friendlypricing}>
            <div className={styles.friendlypricingwrapper}>
              <div className={styles.pricingpricingtitle}>
                <p>Friendly Pricing</p>
              </div>
              <p className={styles.comparetext}>Compare our plans and find yours</p>
              <p className={styles.findperfect}>
                Find the perfect fit for your needs with our adaptable plans and pricing options.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.secondframe}>
        <div className={styles.pricingcontainer}>
          {/* first column- titles */}
          <div className={styles.pricingcolumn}>
            <div className={styles.titlecolumntop}>
              <div className={styles.compareplans}>
                <p className={styles.compareplanstitle}>Compare plans</p>
              </div>
              <p className={styles.whichplan}>Which plan is right for you?</p>
              <div className={styles.overview}>
                <div className={styles.overviewwrapper}>
                  <p className={styles.overviewtext}>Overview</p>
                </div>
              </div>
            </div>
            <div className={styles.titlebottom}>
              <div>
                {titleColumn.slice(0, 6).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {titleColumn.slice(6, 9).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {titleColumn.slice(9, 14).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.smallvoid}></div>
              <div>
                {titleColumn.slice(14, 19).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {titleColumn.slice(19, 25).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.bigvoid}></div>
              <div>
                {titleColumn.slice(25, 31).map(({ id, title }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingcontentwrapper}>
                      <div className={styles.pricingcontenttitle}>{title}</div>
                      <div>{question}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* second column */}
          <div className={styles.pricingcolumn}>
            <div className={styles.titletop}>
              <PricingHeader>
                <div className={styles.planamount}>
                  <p className={styles.planprice}>$0</p>
                  <p className={styles.planname}>Free</p>
                </div>
                <p className={styles.plantypebtn}>Basic</p>
                <p className={styles.pricingdescription}>
                  Basic features for unlimited members with everything you need.
                </p>
              </PricingHeader>
            </div>
            <div className={styles.titlebottom}>
              <div>
                {column1.slice(0, 6).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column1.slice(6, 9).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column1.slice(9, 14).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.smallvoid}></div>
              <div>
                {column1.slice(14, 19).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column1.slice(19, 25).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.bigvoid}></div>
              <div>
                {column1.slice(25, 31).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.pricingcolumn}>
            {/* column 2 */}

            <div className={styles.titletop}>
              <PricingHeader>
                <div className={styles.planamount}>
                  <p className={styles.planprice}>$99</p>
                  <p className={styles.planname}>per month</p>
                </div>
                <p className={styles.plantypebtn}>Business</p>
                <p className={styles.pricingdescription}>
                  Advanced features and reporting, better workflows and engagement.
                </p>
              </PricingHeader>
            </div>
            <div className={styles.titlebottom}>
              <div>
                {column2.slice(0, 6).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column2.slice(6, 9).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column2.slice(9, 14).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.smallvoid}></div>
              <div>
                {column2.slice(14, 19).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column2.slice(19, 25).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.bigvoid}></div>
              <div>
                {column2.slice(25, 31).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.pricingcolumn}>
            {/* column 3 */}
            <div className={styles.titletop}>
              <PricingHeader>
                <div className={styles.planamount}>
                  <p className={styles.planprice}>$299</p>
                  <p className={styles.planname}>per month</p>
                </div>
                <p className={styles.plantypebtn}>Enterprise</p>
                <p className={styles.pricingdescription}>
                  Personalized service and enterprise security for large teams.
                </p>
              </PricingHeader>
            </div>
            <div className={styles.titlebottom}>
              <div>
                {column3.slice(0, 6).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column3.slice(6, 9).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column3.slice(9, 14).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.smallvoid}></div>
              <div>
                {column3.slice(14, 19).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.smallvoid}></div>
              <div>
                {column3.slice(19, 25).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.bigvoid}></div>
              <div>
                {column3.slice(25, 31).map(({ id, desc }) => (
                  <div key={id} className={styles.pricingcontent}>
                    <div className={styles.pricingplan}>
                      <div className={styles.pricingcontenttitle}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.fifthFrame}>
        <div className={styles.thirdFramewrapper}>
          <div className={styles.thirdFrametop}>
            <div className={styles.thirdFramebadge_title}>
              <span className={styles.thirdFramebadge}>get started</span>
              <p className={styles.thirdFrame_title}>Download our App</p>
            </div>
            <p className={styles.thirdFrame_description}>
              Start your journey to empowering your community with our one stop app for building, engaging,
              and empowering your community
            </p>
          </div>

          <div className={styles.thirdFramebottom}>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorebtn} alt="app store button" />
              </Link>

              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googleplaybtn} alt="google play button" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.sixthFrame}>
        <div className={styles.fourthFramewrapper}>
          <FAQ />
        </div>
      </div>
      <div className={styles.seventhFrame}>
        <Footer />
      </div>
    </main>
  );
};

export default Pricing;
